export default __webpack_public_path__ + "static/media/pogodnosti-back.b10f871d.jpg";